module.exports = __webpack_public_path__ + "img/img37.8ddd41c5.svg";